// extracted by mini-css-extract-plugin
export default {"wrapper":"CA-z","button":"DA-z","alternate":"EA-z","disabled":"FA-z","paymentWarning":"GA-z","fadeIn":"HA-z"};